import React from "react";

const textualStyle = {
  maxWidth: "900px",
  margin: "0 auto",
  padding: "8px",
  background: "var(--color-surface-1)",
  border: "1px solid rgba(255, 255, 255, 0.05)",
  lineHeight: "1.9",
  color: "var(--color-text-secondary)",
};

const ShippingPolicy = () => {
  return (
    <div style={textualStyle}>
      <h2
        style={{
          color: "var(--color-text-primary)",
          marginBottom: "15px",
          borderBottom: "1px solid var(--color-border-light, rgba(255,255,255,0.1))",
          paddingBottom: "15px",
        }}
      >
        Shipping & Delivery Policy
      </h2>

      <p
        style={{
          color: "#f97316",
          fontStyle: "italic",
          fontSize: "1.1rem",
          marginBottom: "30px",
        }}
      >
        At Regard Traders, our goal is to get your curated trends and premium cosmetics onto your shelves as quickly and safely as possible.
      </p>

      <p>
        We work with trusted national logistics networks to ensure seamless delivery directly to your business hub.
      </p>

      <h3 style={{ color: "var(--color-text-primary)", marginTop: "30px", marginBottom: "10px" }}>
        1. Exclusions (Packing & Delivery)
      </h3>
      <p>
        To keep our bulk wholesale product rates as low and competitive as possible, all packing charges and delivery fees are excluded from the initial item pricing. These actual costs will be calculated based on your total order volume and added transparently to your final invoice.
      </p>

      <h3 style={{ color: "var(--color-text-primary)", marginTop: "30px", marginBottom: "10px" }}>
        2. Order Processing & Dispatch
      </h3>
      <p>
        Once your 20% commitment deposit is confirmed and your items are securely packed, we prepare your shipment for dispatch.
      </p>

      <h3 style={{ color: "var(--color-text-primary)", marginTop: "30px", marginBottom: "10px" }}>
        3. The 80% Balance Rule
      </h3>
      <p>
        Your shipment will be handed over to our transport partners immediately after the remaining 80% balance payment (including packing and delivery charges) is cleared. We will share your tracking details and update your billing dashboard link right away.
      </p>

      <h3 style={{ color: "var(--color-text-primary)", marginTop: "30px", marginBottom: "10px" }}>
        4. Delivery Timelines
      </h3>
      <p>
        While standard domestic shipments typically arrive within 4–7 business days, delivery times for advanced bookings of premium imported goods may vary based on international freight timelines.
      </p>

      <h3 style={{ color: "var(--color-text-primary)", marginTop: "30px", marginBottom: "10px" }}>
        5. Transit Safety & Immediate Inspection
      </h3>
      <p>
        All shipments are carefully packed in secure, tamper-proof wholesale packaging. Because logistics claims require quick action, we kindly ask that you inspect your shipment and report any issues immediately upon receiving the package, backed by your continuous unboxing video.
      </p>

      <p
        style={{
          marginTop: "40px",
          paddingTop: "20px",
          borderTop: "1px solid var(--color-border-light, rgba(255,255,255,0.1))",
          fontStyle: "italic",
          color: "var(--color-text-secondary, #d4d4d8)",
        }}
      >
        By placing an order with Regard Traders, you acknowledge and agree to the terms outlined in this Shipping & Delivery Policy.
      </p>
    </div>
  );
};

export default ShippingPolicy;
